module.exports = __webpack_public_path__ + "img/logo_blue_lasa.1b9caec.jpg";